import { render, staticRenderFns } from "./v-enterprise-chip.vue?vue&type=template&id=5be604e6&"
import script from "./v-enterprise-chip.vue?vue&type=script&lang=js&"
export * from "./v-enterprise-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports